import { useQuery } from '@tanstack/react-query';
import { supabase } from '../../api';

const getProductByBrand = async (id: string, categoryId?: string) => {
  let query = supabase.from('products').select(`*`).eq('brand', id);
  
  if (categoryId) {
    query = query.eq('category_id', categoryId);
  }

  const { data, error } = await query;

  if (error) {
    throw new Error(error.message);
  }

  return data;
};

export default function useGetProductByBrand(id: string, categoryId?: string) {
  return useQuery({
    queryKey: ['useGetProductByBrand', id, categoryId],
    queryFn: () => getProductByBrand(id, categoryId),
    staleTime: 0,
    enabled: !!id,
  });
}
